import { classNamesFunction, FontWeights, ISpinnerStyles, IStyle, ITheme, IButtonStyles, ITextFieldStyles } from 'office-ui-fabric-react';

import {
  IChoiceNodeStyles,
  IComponentStyleProps,
  IDafNodeStyles,
  IGraphHeaderStyles,
  IInputNodeStyles,
  IIntentGraphStyles,
  INodeHeaderStyles,
  INodeListStyles,
  INodeStyles,
  IRootContainerStyles,
  ISafActionNodeStyles,
  ISafInlineDiagnosticsStyles,
  ISafSpinnerStyles
} from '../types';

export const getCustomStyles = (
  theme: ITheme,
  stylesFunc: (theme: ITheme) => Partial<IIntentGraphStyles>
): Partial<IIntentGraphStyles> => {
  let customStyles = {} as Partial<IIntentGraphStyles>;
  if (typeof stylesFunc === 'function') {
    customStyles = stylesFunc(theme);
  }
  return customStyles;
};

export interface IDefaultTextFieldStyles {
  textFieldBase: IStyle;
  textFieldSpinner: Partial<ISpinnerStyles>;
}

export const getTextFieldDefaultStyles = (props: IComponentStyleProps): Partial<IDefaultTextFieldStyles> => {
  return {
    textFieldBase: {
      '& *': {
        overFlowWrap: 'break-word'
      }
    },
    textFieldSpinner: getTextFieldComponentSpinnerStyles(props)
  };
};

export const getMainAppStyles = (props: IComponentStyleProps): Partial<IRootContainerStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.hostDiv ? c.hostDiv : {};
  const defaultStyles = {
    root: {
      background: theme.palette.white,
      width: '100%',
      height: '100%',
      minWidth: '175px',
      // minHeight: '200px',
      marginTop: '15px',
      fontColor: theme.palette.white,
      fontFamily:
        'Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
      '& > *': {
        fontFamily:
          'Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif'
      }
    }
  };

  return { ...defaultStyles, ...customStyles } as Partial<IRootContainerStyles>;
};

export const getSafDiagnosticsStyles = (props: IComponentStyleProps): Partial<ISafInlineDiagnosticsStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  let customStyles = {}
  if(c){
    if(c.safActionNode && c.safActionNode.inlineDiagnostics){
      customStyles = c.safActionNode.inlineDiagnostics
    }
    else if(c.safNode){
      customStyles = c.safNode
    }
  }

  const defaultStyles = {
    sectionContainer: {
      marginBottom: '32px'
    },
    contentContainer: {
      marginBottom: '16px',
      selectors: {
        a: {
          textDecoration: 'none',
          color: theme.palette.themeDark
        }
      }
    },
    title: {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '22px',
      maxHeight: '44px',
      overflow: 'hidden'
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<ISafInlineDiagnosticsStyles>;
};

export const getSafNodeSpinnerStyles = (props: IComponentStyleProps): Partial<ISafSpinnerStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.safNode ? c.safNode : {};

  const defaultStyles = {
    spinnerStyles: {} as ISpinnerStyles
  };
  return { ...defaultStyles, ...customStyles } as Partial<ISafSpinnerStyles>;
};

export const getInputNodeStyles = (props: IComponentStyleProps): Partial<IInputNodeStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.inputNode ? c.inputNode : {};

  const defaultStyles = {
    textField: {} as ITextFieldStyles,
    button: {} as IButtonStyles
  };
  return { ...defaultStyles, ...customStyles } as Partial<IInputNodeStyles>;
};

export const getSafActionNodeStyles = (props: IComponentStyleProps): Partial<ISafActionNodeStyles> =>{
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.safActionNode ? c.safActionNode : {};

  const defaultStyles = {
    completedIcon: {
      cursor: 'pointer',
      float: 'right',
      color: theme.palette.green
    },
    failedIcon: {
      cursor: 'pointer',
      float: 'right',
      color: theme.palette.red
    },
    label: {
      fontWeight: FontWeights.regular,
      overflow: 'hidden',
      width: '93%',
      textAlign: 'left',
      '& > *': {
        fontWeight: FontWeights.regular,
        overflow: 'hidden',
        'overflow-wrap': 'break-word',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        textAlign: 'left'
      },
      'overflow-wrap': 'break-word',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      minHeight: '24px !important'
    },
    safContainer: {
      margin: '10px',
      marginTop: 0
    },
    spinner:{
      root: {
        marginTop: '10px',
        width: '80%'
      }
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<ISafActionNodeStyles>;
}

export const getDafSpinnerStyles = (props: IComponentStyleProps): Partial<IDafNodeStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.dafSpinner ? c.dafSpinner : {};

  const defaultStyles = {
    completedIcon: {
      cursor: 'pointer',
      float: 'right',
      color: theme.palette.green
    },
    failedIcon: {
      cursor: 'pointer',
      float: 'right',
      color: theme.palette.red
    },
    label: {
      fontWeight: FontWeights.regular,
      overflow: 'hidden',
      width: '93%',
      textAlign: 'left',
      '& > *': {
        fontWeight: FontWeights.regular,
        overflow: 'hidden',
        'overflow-wrap': 'break-word',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        textAlign: 'left'
      },
      'overflow-wrap': 'break-word',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      minHeight: '24px !important'
    },
    dafContainer: {
      margin: '10px',
      marginTop: 0
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<ISpinnerStyles>;
};

export const getHeaderStyles = (props: IComponentStyleProps): Partial<IGraphHeaderStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.mainHeader ? c.mainHeader : {};

  const defaultStyles = {
    headerRootDiv: {
      color: theme.palette.black,
      width: '100%',
      fontsize: '18px',
      '& > *': {
        width: '100%',
        color: theme.palette.black,
        marginLeft: '10px',
        fontWeight: FontWeights.bold,
        overflow: 'hidden',
        'overflow-wrap': 'break-word',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      },
      marginBottom: '20px'
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<IGraphHeaderStyles>;
};

export const getOptionBtnStyles = (props: IComponentStyleProps): Partial<IButtonStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.choice && c.choice.choiceBtn ? c.choice.choiceBtn : {};

  const defaultStyles = {
    root: {
      // background: theme.palette.white,
      border: `1px solid ${theme.palette.themePrimary}`,
      marginRight: '16px',
      marginTop: '16px',
      minWidth: '52px',
      minHeight: '42px',
      width: '80%',
      color: theme.palette.themePrimary,
      transition: '1s'
    },
    label: {
      fontWeight: FontWeights.regular,
      overflow: 'hidden',
      height: '100%',
      width: '93%',
      '& > *': {
        fontWeight: FontWeights.regular,
        overflow: 'hidden',
        'overflow-wrap': 'break-word',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      },
      'overflow-wrap': 'break-word',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      minHeight: '24px !important'
    },
    textContainer: {
      textAlign: 'left',
      overflow: 'hidden',
      '& > span': {
        minHeight: '18px !important'
      }
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<IButtonStyles>;
};

export const getNodeHeaderStyles = (props: IComponentStyleProps): Partial<INodeHeaderStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.nodeHeader ? c.nodeHeader : {};
  const defaultStyles = {
    root: {
      width: '100%',
      background: theme.palette.themeLight,
      color: theme.palette.black,
      display: 'flex',
      padding: '10px',
      paddingRight: '0',
      position: 'relative'
    },
    indexNumber: {
      'padding-right': '5px'
    },
    textDiv: {
      width: '80%',
      overflow: 'hidden'
    },
    nodeLabel: {
      fontSize: '16px',
      '& :first-child': {
        'margin-top': '0'
      },
      '& :last-child': {
        'margin-bottom': '0'
      }
    },
    chosenOptionLabel: {
      '& :first-child': {
        'margin-top': '0'
      },
      '& :last-child': {
        'margin-bottom': '0'
      },
      fontWeight: FontWeights.bold,
      'overflow-wrap': 'break-word',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    editIcon: {
      cursor: 'pointer',
      float: 'right'
    },
    completedIcon: {
      cursor: 'pointer',
      float: 'right',
      color: theme.palette.green
    },
    failedIcon: {
      cursor: 'pointer',
      float: 'right',
      color: theme.palette.red
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<INodeHeaderStyles>;
};

export const getChoiceNodeStyles = (props: IComponentStyleProps): Partial<IChoiceNodeStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.choice ? c.choice : {};

  const defaultStyles = {
    container: {
      width: '100%',
      border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
      overflow: 'hidden',
      marginBottom: '5px'
    },
    listContainer: {
      marginBottom: '10px',
      marginLeft: '10px'
    },
    btnLabel: {
      fontWeight: FontWeights.regular,
      overflow: 'hidden',
      height: '100%',
      width: '100%',
      '& > *': {
        fontWeight: FontWeights.regular,
        overflow: 'hidden',
        'overflow-wrap': 'break-word'
      }
    },
    choiceBtn: getOptionBtnStyles(props),
    editIcon: {
      cursor: 'pointer',
      float: 'right'
    },
    editIconWrapper: {
      height: '32px', 
      width: '32px',
      boxSizing: 'border-box',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex'
    },
    choicesList: {
      margin: '10px',
      marginTop: 0
    },
    spinner:{
      root: {
        marginTop: '10px',
        width: '80%'
      }
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<IChoiceNodeStyles>;
};

export const getNodeListStyles = (props: IComponentStyleProps): Partial<INodeListStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.nodeList ? c.nodeList : {};
  const defaultStyles = {
    startNodeContainer: {
      width: '100%',
      overflow: 'hidden',
      marginBottom: '10px'
    },
    container: {
      width: '100%',
      overflow: 'hidden',
      minHeight: '100px'
    },
    listContainer: {
      height: '100%',
      width: '100%'
    },
    textNodeContainer: {
      // background: theme.palette.neutralQuaternaryAlt,
      width: '100%',
      // border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
      overflow: 'hidden',
      marginTop: '-10px',
      paddingTop: '10px',
      transition: '1s'
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<INodeListStyles>;
};

export const getNodeStyles = (props: IComponentStyleProps): Partial<INodeStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.node ? c.node : {};

  const defaultStyles = {
    startNodeLabel: {
      color: theme.palette.black,
      marginLeft: '10px',
      display: 'inline',
      fontSize: '16px',
      '& :first-child': {
        'margin-top': '0',
        marginLeft: '10px'
      },
      '& :last-child': {
        'margin-bottom': '0'
      }
    },
    hairline: {
      width: '75%',
      margin: '10px',
      marginTop: 0
    },
    content: {
      color: theme.palette.black,
      width: '80%',
      margin: '10px',
      marginTop: '0px',
      '&  *': {
        marginTop: '5px',
        marginBottom: '0'
      },
      '& ol': {
        padding: '0px 0px 0px 20px'
      },
      '& ul': {
        padding: '0px 0px 0px 20px'
      },
      '& li': {
        padding: '13px 0px 3px 0px'
      }
    },
    contentTitle: {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '22px',
      maxHeight: '44px',
      overflow: 'hidden'
    },
    question: {
      color: theme.palette.black,
      width: '80%',
      margin: '10px',
      marginTop: 0,
      marginBottom: 0,
      fontWeight: 'bold'
    },
    nodeWithSecondaryText: {
      backgroundColor: theme.palette.themeLighter,
      border: '1px solid transparent'
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<INodeStyles>;
};

export const getTextFieldComponentSpinnerStyles = (props: IComponentStyleProps): Partial<ISpinnerStyles> => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  const customStyles = c && c.textFieldSpinner ? c.textFieldSpinner : {};

  const defaultStyles = {};
  return { ...defaultStyles, ...customStyles } as Partial<ISpinnerStyles>;
};

export const getsafDiagnosticsClassNames = classNamesFunction<{}, Partial<ISafInlineDiagnosticsStyles>>();
export const getMainAppClassNames = classNamesFunction<{}, Partial<IRootContainerStyles>>();
export const getChoiceNodeClassNames = classNamesFunction<{}, Partial<IChoiceNodeStyles>>();
export const getNodeHeaderClassNames = classNamesFunction<{}, Partial<INodeHeaderStyles>>();
export const getNodeClassNames = classNamesFunction<{}, Partial<INodeStyles>>();
export const getHeaderClassNames = classNamesFunction<{}, Partial<IGraphHeaderStyles>>();
export const getNodeListClassNames = classNamesFunction<{}, Partial<INodeListStyles>>();
export const getSafNodeClassNames = classNamesFunction<{}, Partial<ISafSpinnerStyles>>();
export const getSafActionNodeClassNames = classNamesFunction<{}, Partial<ISafActionNodeStyles>>();
export const getDafNodeClassNames = classNamesFunction<{}, Partial<IDafNodeStyles>>();
export const getTextFieldDefaultClassNames = classNamesFunction<{}, Partial<IDefaultTextFieldStyles>>();
export const getInputNodeClassNames = classNamesFunction<{}, Partial<IInputNodeStyles>>();
